import type { AlertDialogProps } from './Dialog.types';
import type { ReactElement } from 'react';

import { AlertSheet } from '@rango-dev/whale/lab';
import React from 'react';

import { useMediaQuery } from '../../hooks/useMediaQuery';

import { DesktopAlertDialog } from './AlertDialog.Desktop';

/**
 * Responsive alert dialog — a centered Radix Themes AlertDialog from 640px up,
 * the local `AlertSheet` (bottom sheet) below it. For critical, non-dismissible
 * confirmations; the footer action is required.
 */
export function AlertDialog(props: AlertDialogProps): ReactElement {
  const isDesktop = useMediaQuery('(min-width: 640px)');
  return isDesktop ? <DesktopAlertDialog {...props} /> : <AlertSheet {...props} />;
}
